module.exports = __webpack_public_path__ + "static/media/blogImg3.45640bba.png";